import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-users-screen-block-create',
    templateUrl: 'configuration-users-screen-block-create.html',
})
export class ConfigurationUsersScreenBlockCreatePage {

    public form: FormGroup;
    update_state: boolean = false;
    user: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public globals: Globals,
        private alertCtrl: AlertController,
        public configurationServices: ConfigurationServices,
        public loadingCtrl: LoadingController,
        public translate: TranslateService) {


        this.update_state = this.navParams.get('update_state');

        if (this.update_state) {
            this.user = this.navParams.get('user');
            

            this.form = fb.group({
                uid: [this.user.uid, Validators.compose([Validators.required])],
                email: [this.user.email, Validators.compose([Validators.required])],
                name: [this.user.name, Validators.compose([Validators.required])],
                code: [this.user.code, Validators.compose([Validators.required])],
                user: [this.user, Validators.compose([Validators.required])],
            });
        } else {
            this.form = fb.group({
                uid: [''],
                email: [''],
                name: [''],
                code: ['', Validators.compose([Validators.required])],
                user: ['', Validators.compose([Validators.required])],
            });
        }

    }

    submit() {
        if (!this.update_state) {
            this.form.value.uid = this.form.value.user.UID;
            this.form.value.email = this.form.value.user.email;
            this.form.value.name = this.form.value.user.name;
        }

        if (this.form.valid) {
            if (!this.update_state) {
                this.insert();
            } else {
                this.update();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-completa-todos-campos'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    async insert() {
        //se comprueba que el usuario no este creado para pantalla bloqueo
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        var users = await this.configurationServices.getUsersScreenBlockAsync(this.globals.restaurant_uid);
        var _user = users.find(user => user.email == this.form.value.email);
        loadingPopup.dismiss();

        if (_user == undefined) {//si no existe crear usuario
            this.configurationServices.afs.collection('screen_block').add({
                'UID_RESTAURANT': this.globals.restaurant_uid,
                'uid': this.form.value.uid,
                'email': this.form.value.email,
                'name': this.form.value.name,
                'code': this.form.value.code,
            }).then(() => {
                this.navCtrl.pop();
            });

        } else {//si existe mostrar mensaje
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-usuario-tiene-codigo-acceso'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }






    }

    update() {
        this.configurationServices.afs.collection('screen_block').doc(this.user.UID).update({
            'uid': this.form.value.uid,
            'email': this.form.value.email,
            'name': this.form.value.name,
            'code': this.form.value.code,
        }).then(() => {
            this.navCtrl.pop();
        });
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-usuario-pantalla-bloqueo'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {

                        this.configurationServices.afs.doc('screen_block/' + this.user.UID).delete();
                        this.navCtrl.pop();
                    }
                }
            ]
        });
        alert.present();
    }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-users-screen-block/configuration-users-screen-block-create/configuration-users-screen-block-create.ts